var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWelcomeDesktopAccent({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 755,
    height: 24,
    viewBox: "0 0 755 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.447 11.7935C120.649 4.12082 432.546 -4.93462 750.517 20.2251",
    stroke: "#60C2A5",
    strokeWidth: 7,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeDesktopAccent);
export default __webpack_public_path__ + "static/media/WelcomeDesktopAccent.5b935ec02f5b56ec7d3d3574c75f7cf8.svg";
export { ForwardRef as ReactComponent };